/* Fjordlighting x Blossholm: shared behaviour (header drawers + search, carousels, tabs, sort, product form).
   No dependencies. Everything is wired by data attributes, so sections can be re-rendered in the theme editor. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- sticky chrome height (announcement + header) ---------- */
  function chrome() {
    var ann = $('.fj-ann-section'), head = $('.fj-header-section');
    var a = ann ? ann.getBoundingClientRect().height : 0, h = head ? head.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--fj-ann-h', a + 'px');
    document.documentElement.style.setProperty('--fj-chrome-h', (a + h) + 'px');
  }

  /* ---------- drawers: menu + search ---------- */
  var openDrawer = null, lastFocus = null;
  function overlay() {
    var o = $('.fj-overlay');
    if (!o) { o = document.createElement('div'); o.className = 'fj-overlay'; document.body.appendChild(o); o.addEventListener('click', closeDrawer); }
    return o;
  }
  function open(el) {
    if (!el) return;
    if (openDrawer && openDrawer !== el) closeDrawer();
    chrome();
    lastFocus = document.activeElement;
    openDrawer = el; el.classList.add('is-open'); el.removeAttribute('inert'); el.setAttribute('aria-hidden', 'false');
    overlay().classList.add('is-open'); document.body.classList.add('fj-lock');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = $('input, button, a', el); if (f) setTimeout(function () { try { f.focus({ preventScroll: true, focusVisible: false }); } catch (x) { f.focus(); } }, 60);
  }
  function closeDrawer() {
    if (!openDrawer) return;
    var el = openDrawer; openDrawer = null;
    el.classList.remove('is-open'); el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true');
    overlay().classList.remove('is-open'); document.body.classList.remove('fj-lock');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fj-open]');
    if (t) { e.preventDefault(); open(document.getElementById(t.getAttribute('data-fj-open'))); return; }
    if (e.target.closest('[data-fj-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); $$('.fj-sort.is-open').forEach(function (s) { s.classList.remove('is-open'); }); closeLightbox(); }
  });

  /* predictive search (Shopify's /search/suggest.json) */
  var searchTimer = null, searchCtl = null;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('.fj-search__input');
    if (!input) return;
    var box = $('.fj-search__results', input.closest('.fj-search'));
    clearTimeout(searchTimer);
    var q = input.value.trim();
    if (!q) { box.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      if (searchCtl) searchCtl.abort();
      searchCtl = 'AbortController' in window ? new AbortController() : null;
      fetch(ROOT + 'search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&section_id=fj-predictive-search', searchCtl ? { signal: searchCtl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var el = new DOMParser().parseFromString(html, 'text/html').getElementById('fj-ps');
          box.innerHTML = el ? el.innerHTML : '';
        }).catch(function () {});
    }, 220);
  });
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- money ---------- */
  function formatMoney(cents, fmt) {
    fmt = fmt || window.FJ_MONEY || (window.Shopify && Shopify.money_format) || '{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    function fmtNum(n, d, ts, ds) {
      d = d == null ? 2 : d; ts = ts == null ? ',' : ts; ds = ds == null ? '.' : ds;
      var x = (n / 100).toFixed(d).split('.');
      return x[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts) + (x[1] ? ds + x[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return fmtNum(cents, 2);
        case 'amount_no_decimals': return fmtNum(cents, 0);
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmtNum(cents, 0, ' ', '');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmtNum(cents, 2, ' ', '.');
        default: return fmtNum(cents, 2);
      }
    });
  }
  window.fjFormatMoney = formatMoney;

  /* ---------- rails: arrows + progress ---------- */
  function initRail(wrap) {
    if (wrap.__fj) return; wrap.__fj = true;
    var rail = $('.fj-rail', wrap), bar = $('.fj-progress span', wrap);
    var prev = $('[data-fj-prev]', wrap), next = $('[data-fj-next]', wrap);
    if (!rail) return;
    function step() { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : rail.clientWidth; }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth, x = rail.scrollLeft;
      if (bar) { var w = Math.max(0.08, rail.clientWidth / rail.scrollWidth); bar.style.width = (w * 100) + '%'; bar.style.transform = 'translateX(' + (max > 0 ? (x / max) * ((1 - w) / w) * 100 : 0) + '%)'; }
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- "You may also like": Shopify's recommendations for this product replace the fallback cards ---------- */
  function loadRecs(sec) {
    fetch(sec.getAttribute('data-url'), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-fj-recs] .fj-rail'), rail = $('.fj-rail', sec);
      if (!fresh || !rail || fresh.children.length < 4) return;   // too few: the fallback cards stay
      rail.innerHTML = fresh.innerHTML; rail.scrollLeft = 0;
      rail.dispatchEvent(new Event('scroll'));   // progress bar + arrows (initRail)
    }).catch(function () {});
  }
  var recsIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { recsIO.unobserve(e.target); loadRecs(e.target); } });
  }, { rootMargin: '1000px 0px' }) : null;
  function initRecs(sec) {
    if (sec.__fjRecs || !sec.getAttribute('data-url')) return; sec.__fjRecs = true;
    if (recsIO) recsIO.observe(sec); else loadRecs(sec);
  }

  /* focus rings only for keyboard users: a mouse or touch click never leaves a box (Safari focuses summaries on click) */
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') document.documentElement.classList.add('fj-kbd'); });
  document.addEventListener('pointerdown', function () { document.documentElement.classList.remove('fj-kbd'); });

  /* videos: play only while visible */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.src && v.dataset.src) { v.src = v.dataset.src; }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) v.pause();
    });
  }, { rootMargin: '200px 0px' }) : null;

  /* header dropdowns: close on outside click / Escape, only one open */
  document.addEventListener('click', function (e) {
    $$('.fj-header__dd[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.fj-header__dd[open]').forEach(function (d) { d.removeAttribute('open'); }); });

  /* ---------- tabs ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.fj-tabs__btn');
    if (!b) return;
    var root = b.closest('.fj-tabs');
    $$('.fj-tabs__btn', root).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); x.tabIndex = x === b ? 0 : -1; });
    $$('.fj-tabs__panel', root).forEach(function (p) { p.hidden = p.id !== b.getAttribute('aria-controls'); });
  });

  /* ---------- sort ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.fj-sort__btn');
    $$('.fj-sort.is-open').forEach(function (s) { if (!b || !s.contains(b)) s.classList.remove('is-open'); });
    if (b) { var s = b.closest('.fj-sort'); s.classList.toggle('is-open'); b.setAttribute('aria-expanded', s.classList.contains('is-open')); }
  });

  /* ---------- lightbox ---------- */
  var lb = null;
  function openLightbox(gallery, index) {
    var imgs = $$('.fj-gallery__item:not(.fj-gallery__item--video):not(.is-other) img', gallery);
    if (!imgs.length) return;
    if (!lb) {
      lb = document.createElement('div'); lb.className = 'fj-lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
      lb.innerHTML = '<div class="fj-lightbox__list"></div><button class="fj-lightbox__close" type="button" aria-label="Close"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17.66 6.34 6.34 17.66M17.66 17.66 6.34 6.34"/></svg></button>' +
        '<button class="fj-lightbox__nav fj-lightbox__nav--prev" type="button" aria-label="Previous"><svg width="7" height="11" viewBox="0 0 5 8" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m4.25 1-3 3 3 3"/></svg></button>' +
        '<button class="fj-lightbox__nav fj-lightbox__nav--next" type="button" aria-label="Next"><svg width="7" height="11" viewBox="0 0 5 8" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m.75 7 3-3-3-3"/></svg></button>';
      document.body.appendChild(lb);
      lb.querySelector('.fj-lightbox__close').addEventListener('click', closeLightbox);
      var list = lb.querySelector('.fj-lightbox__list');
      lb.querySelector('.fj-lightbox__nav--prev').addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth, behavior: 'smooth' }); });
      lb.querySelector('.fj-lightbox__nav--next').addEventListener('click', function () { list.scrollBy({ left: list.clientWidth, behavior: 'smooth' }); });
    }
    var list2 = lb.querySelector('.fj-lightbox__list');
    list2.innerHTML = imgs.map(function (im) { var src = (im.currentSrc || im.src).replace(/width=\d+/, 'width=2000'); return '<figure><img src="' + src + '" alt="' + esc(im.alt) + '"></figure>'; }).join('');
    lb.classList.add('is-open'); document.body.classList.add('fj-lock');
    requestAnimationFrame(function () { list2.scrollLeft = list2.clientWidth * Math.max(0, index); });
  }
  function closeLightbox() { if (lb && lb.classList.contains('is-open')) { lb.classList.remove('is-open'); document.body.classList.remove('fj-lock'); } }

  /* ---------- product ---------- */
  function initProduct(root) {
    if (root.__fj) return; root.__fj = true;
    var data; try { data = JSON.parse($('[data-fj-product-json]', root).textContent); } catch (e) { return; }
    var form = $('form[data-fj-form]', root), idInput = form && $('input[name="id"]', form);
    var gallery = $('.fj-gallery', root), list = gallery && $('.fj-gallery__list', gallery);
    var btn = $('.fj-buy__btn', root), label = btn && $('.fj-buy__label', btn), err = $('.fj-buy__error', root);
    var sticky = $('.fj-sticky-atc', root);
    var current = data.variants.filter(function (v) { return v.id === data.current; })[0] || data.variants[0];

    function selected() {
      return data.options.map(function (o, i) { var c = $('input[name="fj-opt-' + i + '"]:checked', root); return c ? c.value : (current.options[i]); });
    }
    function find(opts) { return data.variants.filter(function (v) { return v.options.every(function (x, i) { return x === opts[i]; }); })[0]; }
    function visThumbs() { return gallery ? $$('.fj-gallery__thumbs button', gallery).filter(function (t) { return !t.classList.contains('is-other'); }) : []; }

    function render(v, fromUser) {
      if (!v) {
        if (btn) { btn.disabled = true; label.textContent = data.t.unavailable; }
        return;
      }
      current = v;
      if (idInput) idInput.value = v.id;
      if (fromUser && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
      var price = v.price, cmp = v.compare || '';
      $$('[data-fj-price]', root).forEach(function (el) { el.textContent = price; });
      $$('[data-fj-compare]', root).forEach(function (el) { el.textContent = cmp; el.hidden = !cmp; });
      // the amount saved in the shopper's currency, not the % (Leon 2026-10-22)
      $$('[data-fj-save]', root).forEach(function (el) { el.textContent = data.t.save.replace('[percent]', v.saveMoney).replace('[amount]', v.saveMoney); el.hidden = !v.save; });
      $$('.fj-stock', root).forEach(function (el) { el.classList.toggle('is-out', !v.available); var t = $('.fj-stock__text', el); if (t) t.textContent = v.available ? data.t.instock : data.t.soldout; });
      if (btn) { btn.disabled = !v.available; label.textContent = v.available ? data.t.add.replace('[price]', price) : data.t.soldout; }
      $$('[data-fj-sticky-price]', root).forEach(function (el) { el.textContent = price; });
      // selected option labels + availability of the other values
      data.options.forEach(function (o, i) {
        var lab = $('[data-fj-opt-value="' + i + '"]', root); if (lab) lab.textContent = v.options[i];
        $$('input[name="fj-opt-' + i + '"]', root).forEach(function (inp) {
          var test = v.options.slice(); test[i] = inp.value;
          var m = find(test); var wrap = inp.closest('.fj-swatch, .fj-pill');
          if (wrap) wrap.classList.toggle('is-unavailable', !m || !m.available);
          inp.checked = inp.value === v.options[i];
        });
      });
      // beige studio photo of this colour: first gallery photo, tab photo, sticky bar (matched by value position)
      var ci = data.colorIndex, pos = ci > -1 ? (data.optionValues[ci] || []).indexOf(v.options[ci]) + 1 : 0;
      // a studio photo of this size + colour first (key "<size>|<colour>", 2026-10-28: the Small Designer Mushroom), then the colour's
      var hsi = data.sizeIndex, hsp = hsi > -1 ? (data.optionValues[hsi] || []).indexOf(v.options[hsi]) + 1 : 0;
      var img = (hsp && data.colorImages[hsp + '|' + pos]) || (pos && data.colorImages[String(pos)]) || data.colorImages['0'] || null;
      if (img) {
        $$('[data-fj-hero]').forEach(function (el) {
          if (el.getAttribute('data-fj-current') === img.src) return;
          el.setAttribute('data-fj-current', img.src); el.removeAttribute('srcset'); el.src = img.src;
        });
        var thumb = $('.fj-gallery__thumbs button:first-child img', root); if (thumb) { thumb.removeAttribute('srcset'); thumb.src = img.thumb; }
        var st = $('.fj-sticky-atc__info img', root); if (st) { st.removeAttribute('srcset'); st.src = img.thumb; }
      }
      // the colour swatches follow the size too when a size has its own studio photos (keys "<size>|<colour>")
      if (ci > -1 && Object.keys(data.colorImages || {}).some(function (k) { return k.indexOf('|') > -1; })) {
        $$('input[name="fj-opt-' + ci + '"]', root).forEach(function (inp) {
          var p = (data.optionValues[ci] || []).indexOf(inp.value) + 1, im = (hsp && data.colorImages[hsp + '|' + p]) || data.colorImages[String(p)];
          var sw = inp.closest('.fj-swatch'), el = sw && $('.fj-swatch__img img', sw);
          if (im && el && el.getAttribute('data-fj-current') !== im.thumb) { el.setAttribute('data-fj-current', im.thumb); el.removeAttribute('srcset'); el.src = im.thumb; }
        });
      }
      // "Gallery photo per colour" (2026-10-21): only the photos of this colour (data-fj-colour 0 = every colour); the
      // first 6 shown stay visible in the collapsed grid, the gallery starts at its first photo again
      if (gallery && gallery.classList.contains('fj-gallery--bycolour') && gallery.getAttribute('data-fj-cpos') !== String(pos)) {
        var n = 0;
        $$('.fj-gallery__item', gallery).forEach(function (it) {
          var c = Number(it.getAttribute('data-fj-colour') || 0), other = c > 0 && c !== pos;
          it.classList.toggle('is-other', other); if (!other) n++; it.classList.toggle('is-more', !other && n > 6);
        });
        $$('.fj-gallery__thumbs button', gallery).forEach(function (t) { var c = Number(t.getAttribute('data-fj-colour') || 0); t.classList.toggle('is-other', c > 0 && c !== pos); });
        visThumbs().forEach(function (t, k) { t.classList.toggle('is-active', k === 0); });
        if (list) list.scrollTo({ left: 0 });
        gallery.setAttribute('data-fj-cpos', String(pos));
      }
      // photo of this size and colour (tabs size drawing, size section, close-up): the element carries its own map, cm or
      // inches already chosen in Liquid. Keys: "<size>|<colour>" (that colour's), "0|<colour>" (colour, any size),
      // "<size>" (every colour), "0|0" (the section's default photo). No size option = size 1.
      var si = data.sizeIndex, spos = si > -1 ? (data.optionValues[si] || []).indexOf(v.options[si]) + 1 : 0, sk = spos || 1;
      $$('[data-fj-size-img]').forEach(function (el) {
        var map; try { map = JSON.parse(el.getAttribute('data-map')); } catch (x) { return; }
        var u = map[sk + '|' + pos] || map['0|' + pos] || map[String(sk)] || map['0|0'];
        // tabs photo: a size without a drawing shows the studio photo (data-fallback) instead of the last size's drawing
        if (!u && spos) u = el.getAttribute('data-fallback');
        if (u && el.getAttribute('data-fj-current') !== u) { el.setAttribute('data-fj-current', u); el.removeAttribute('srcset'); el.src = u; }
      });
      document.dispatchEvent(new CustomEvent('fj:variant', { detail: { variant: v } }));
      if (fromUser && list && window.matchMedia('(max-width: 999px)').matches) list.scrollTo({ left: 0, behavior: 'smooth' });
    }

    root.addEventListener('change', function (e) {
      if (!e.target.matches('input[name^="fj-opt-"]')) return;
      var opts = selected(), v = find(opts);
      if (!v || !v.available) {   // keep the clicked value, pick the closest available combination
        var i = Number(e.target.name.replace('fj-opt-', ''));
        var alt = data.variants.filter(function (x) { return x.options[i] === e.target.value && x.available; })[0] || data.variants.filter(function (x) { return x.options[i] === e.target.value; })[0];
        if (alt) v = alt;
      }
      if (err) err.hidden = true;
      render(v, true);
    });

    // quantity
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-fj-qty]'); if (!q) return;
      var inp = $('.fj-qty input', root); var n = Math.max(1, (parseInt(inp.value, 10) || 1) + Number(q.dataset.fjQty)); inp.value = n;
    });

    // add to cart -> theme cart drawer
    function add(e) {
      if (e) e.preventDefault();
      if (!current || !current.available || btn.classList.contains('is-loading')) return;
      var qty = Math.max(1, parseInt(($('.fj-qty input', root) || {}).value, 10) || 1);
      [btn, sticky && $('.fj-buy__btn', sticky)].forEach(function (b) { if (b) b.classList.add('is-loading'); });
      cartPost('cart/add.js', { items: [{ id: current.id, quantity: qty }] })
        .then(function (res) {
          if (!cd()) { location.href = ROOT + 'cart'; return; }
          var apply = function (sections) { applySections(sections); cdOpen(); };
          if (res.sections && res.sections['cart-drawer']) apply(res.sections);
          else return fetchCartSections().then(apply);
        })
        .catch(function (j) { if (err) { err.textContent = (j && (j.description || j.message)) || data.t.error; err.hidden = false; } })
        .finally(function () { [btn, sticky && $('.fj-buy__btn', sticky)].forEach(function (b) { if (b) b.classList.remove('is-loading'); }); });
    }
    if (form) form.addEventListener('submit', add);
    // sticky bar on a product with choices (colour / size): the variant sheet of the cart drawer opens so the shopper
    // picks first (Egbert 2026-10-20: "now you have no choice"); a product without choices is added at once
    var hasChoice = (data.optionValues || []).some(function (vals) { return vals && vals.length > 1; });
    function sheetProduct() {
      var ci = data.colorIndex, stImg = sticky && $('.fj-sticky-atc__info img', sticky);
      var imgOf = function (v) { var pos = ci > -1 ? (data.optionValues[ci] || []).indexOf(v.options[ci]) + 1 : 0, si2 = data.sizeIndex, sp2 = si2 > -1 ? (data.optionValues[si2] || []).indexOf(v.options[si2]) + 1 : 0;
        var im = (sp2 && data.colorImages[sp2 + '|' + pos]) || (pos && data.colorImages[String(pos)]) || data.colorImages['0']; return im ? im.thumb : null; };
      return { title: (($('.fj-sticky-atc__title', sticky) || {}).textContent || '').trim(), url: location.pathname, colorIndex: ci,
        image: stImg ? (stImg.currentSrc || stImg.src) : null,
        options: data.options.map(function (n, i) { return { name: n, values: data.optionValues[i] || [] }; }),
        variants: data.variants.map(function (v) { return { id: v.id, options: v.options, available: v.available, price: v.price, compare: v.compare || null, image: imgOf(v) }; }),
        first: (current && current.id) || data.variants[0].id };
    }
    if (sticky) $('.fj-buy__btn', sticky).addEventListener('click', function (e) {
      if (hasChoice && window.fjCart && fjCart.choose && fjCart.choose(sheetProduct(), e.currentTarget)) { e.preventDefault(); return; }
      add(e);
    });

    // sticky add-to-cart (phone/tablet): visible once the main button has scrolled above the screen, hidden at the footer
    if (sticky && btn) {
      var footerEl = document.querySelector('.fj-footer');
      var check = function () {
        var past = btn.getBoundingClientRect().bottom < 0;
        var atFooter = footerEl ? footerEl.getBoundingClientRect().top < window.innerHeight : false;
        var show = past && !atFooter;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var sb = $('.fj-buy__btn', sticky); if (sb) sb.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    }

    // gallery: view more, lightbox, phone thumbs
    if (gallery) {
      var more = $('.fj-gallery__more', gallery);
      if (more) more.addEventListener('click', function () { gallery.classList.remove('is-collapsed'); });
      gallery.addEventListener('click', function (e) {
        var it = e.target.closest('.fj-gallery__item'); if (!it) return;
        var vid = $('video', it);
        if (vid) { if (vid.paused) { vid.play(); it.classList.add('is-playing'); } else { vid.pause(); it.classList.remove('is-playing'); } return; }
        if (window.matchMedia('(max-width: 999px)').matches && !e.target.closest('.fj-gallery__zoom')) return;
        var items = $$('.fj-gallery__item:not(.fj-gallery__item--video):not(.is-other)', gallery);
        openLightbox(gallery, items.indexOf(it));
      });
      var thumbs = $$('.fj-gallery__thumbs button', gallery);
      thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = visThumbs().indexOf(t); list.scrollTo({ left: list.clientWidth * Math.max(0, i), behavior: 'smooth' }); }); });
      if (list && thumbs.length) list.addEventListener('scroll', function () {
        var i = Math.round(list.scrollLeft / Math.max(1, list.clientWidth)), vt = visThumbs();
        vt.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        var a = vt[i]; if (a && a.parentNode.scrollTo) { var p = a.parentNode; var l = a.offsetLeft - p.clientWidth / 2 + a.clientWidth / 2; p.scrollTo({ left: l, behavior: 'smooth' }); }
      }, { passive: true });
    }
    render(current, false);
  }
  /* ---------- cart drawer (Blossholm layout, sections/cart-drawer.liquid) ---------- */
  var CART_SECTIONS = 'cart-drawer,cart-icon-bubble';
  function cd() { return $('fj-cart-drawer'); }
  function cartPost(url, body) {
    body.sections = CART_SECTIONS; body.sections_url = location.pathname;
    return fetch(ROOT + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || (j && j.status && j.status >= 400)) throw j; return j; }); });
  }
  function fetchCartSections() {
    // no "Accept: application/json" here: on a product URL Shopify would answer with the product JSON instead of the sections
    return fetch(location.pathname + '?sections=' + CART_SECTIONS).then(function (r) { return r.json(); });
  }
  function applySections(sections) {
    if (!sections) return;
    var d = cd();
    if (d && sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = $('[data-fj-cd-inner]', doc), cur = $('[data-fj-cd-inner]', d);
      if (fresh && cur) {
        var a = document.activeElement, keep = null;
        if (a && cur.contains(a)) { var it = a.closest('.fj-cd__item'); keep = { key: it && it.dataset.key, q: a.getAttribute('data-fj-cd-qty'), inp: a.hasAttribute('data-fj-cd-qinput') }; }
        var node = document.importNode(fresh, true);
        cur.parentNode.replaceChild(node, cur);
        if (keep) {
          var f = null, row = keep.key && $$('.fj-cd__item', node).filter(function (x) { return x.dataset.key === keep.key; })[0];
          if (row) f = $$(keep.q ? '[data-fj-cd-qty="' + keep.q + '"]' : (keep.inp ? '[data-fj-cd-qinput]' : '[data-fj-cd-remove]'), row).filter(function (x) { return x.offsetParent !== null; })[0];
          (f || $('.fj-cd__panel', d)).focus({ preventScroll: true });
        }
        initTrack(d); fjCountry.apply(d);
      }
    }
    if (sections['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      var t = document.getElementById('cart-icon-bubble'); if (b && t) t.innerHTML = b.innerHTML;
    }
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
  function refreshCart() { if (cd()) fetchCartSections().then(applySections).catch(function () {}); }
  var cdLast = null;
  function cdOpen() {
    var d = cd(); if (!d) return false;
    if (openDrawer) closeDrawer();
    if (!d.classList.contains('is-open')) cdLast = document.activeElement;
    d.hidden = false;
    void d.offsetWidth;
    d.classList.add('is-open');
    document.documentElement.classList.add('fj-lock');
    initTrack(d); fjCountry.apply(d);
    setTimeout(function () { var pn = $('.fj-cd__panel', d); if (pn && !pn.contains(document.activeElement)) pn.focus({ preventScroll: true }); }, 60);
    return true;
  }
  function cdClose() {
    var d = cd(); if (!d || !d.classList.contains('is-open')) return;
    qbClose(true);
    d.classList.remove('is-open', 'is-cursor');
    document.documentElement.classList.remove('fj-lock');
    setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 520);
    if (cdLast && document.contains(cdLast) && cdLast.focus) { try { cdLast.focus({ preventScroll: true }); } catch (x) {} }
  }
  function cdError(anchor, msg) {
    if (!anchor) return;
    var old = $('.fj-cd__err', anchor.parentNode); if (old) old.remove();
    var p = document.createElement('p'); p.className = 'fj-cd__err'; p.setAttribute('role', 'alert'); p.textContent = msg || (cd() && cd().dataset.error) || '';
    anchor.insertAdjacentElement('afterend', p);
  }
  function changeQty(item, qty) {
    if (!item) return;
    qty = Math.max(0, qty | 0);
    item.classList.add('is-loading');
    cartPost('cart/change.js', { id: item.dataset.key, quantity: qty })
      .then(function (res) { applySections(res.sections); })
      .catch(function (j) {
        item.classList.remove('is-loading');
        $$('[data-fj-cd-qinput]', item).forEach(function (i) { i.value = item.dataset.qty; });
        cdError($('.fj-cd__meta', item), j && (j.description || j.message));
      });
  }
  function addVariant(btn, id) {
    var d = cd(), label = btn.textContent;
    btn.classList.add('is-loading'); btn.disabled = true;
    if (btn.classList.contains('fj-cd__add') && d.dataset.adding) btn.textContent = d.dataset.adding;
    return cartPost('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function (res) { btn.classList.remove('is-loading'); btn.disabled = false; btn.textContent = label; applySections(res.sections); return res; })
      .catch(function (j) { btn.classList.remove('is-loading'); btn.disabled = false; btn.textContent = label; throw j; });
  }
  function initTrack(d) {
    var tr = $('[data-fj-cd-track]', d); if (!tr) return;
    if (!tr._fj) { tr._fj = true; tr.addEventListener('scroll', function () { navTrack(d); }, { passive: true }); }
    navTrack(d);
  }
  function navTrack(d) {
    var tr = $('[data-fj-cd-track]', d); if (!tr) return;
    var max = tr.scrollWidth - tr.clientWidth - 2;
    $$('[data-fj-cd-scroll]', d).forEach(function (b) { b.disabled = Number(b.getAttribute('data-fj-cd-scroll')) < 0 ? tr.scrollLeft <= 2 : tr.scrollLeft >= max; });
  }
  function scrollTrack(d, dir) {
    var tr = $('[data-fj-cd-track]', d), card = tr && $('.fj-cd__rec', tr); if (!card) return;
    tr.scrollBy({ left: dir * (card.getBoundingClientRect().width + 8), behavior: 'smooth' });
  }
  /* quick add (products with options) */
  var qbState = null;
  function qbEl() { var d = cd(); return d && $('[data-fj-qb]', d); }
  function qbVariant() {
    var sel = qbState.sel;
    return qbState.p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null;
  }
  function qbOpen(pid, trigger, given) {
    var d = cd(), qb = qbEl(), src = !given && d && $('[data-fj-qb-product="' + pid + '"]', d);
    if (!qb || (!src && !given)) return;
    var p = given; if (!p) { try { p = JSON.parse(src.textContent); } catch (x) { return; } }
    var v = p.variants.filter(function (x) { return x.id === p.first; })[0] || p.variants[0];
    qbState = { p: p, sel: v.options.slice(), trigger: trigger };
    var name = $('[data-fj-qb-name]', qb); name.textContent = p.title; name.href = p.url;
    var box = $('[data-fj-qb-options]', qb); box.innerHTML = '';
    p.options.forEach(function (o, i) {
      var g = document.createElement('div'); g.className = 'fj-qb__opt'; g.setAttribute('role', 'group'); g.setAttribute('aria-label', o.name);
      var lab = document.createElement('p'); lab.className = 'fj-qb__opt-label';
      var n = document.createElement('span'); n.textContent = o.name + ':';
      var c = document.createElement('span'); c.setAttribute('data-fj-qb-cur', i);
      lab.appendChild(n); lab.appendChild(c); g.appendChild(lab);
      var vals = document.createElement('div'); vals.className = 'fj-qb__vals';
      // the colour option as photo swatches, like the product page (Egbert 2026-10-20); other options stay text buttons
      var imgs = swatchImages(p, i);
      o.values.forEach(function (val) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'fj-qb__val';
        if (imgs) {
          b.classList.add('fj-qb__sw'); b.setAttribute('aria-label', val);
          var box = document.createElement('span'); box.className = 'fj-qb__sw-img';
          var im = document.createElement('img'); im.src = imgs[val]; im.alt = ''; im.loading = 'lazy'; box.appendChild(im);
          var nm = document.createElement('span'); nm.className = 'fj-qb__sw-name'; nm.textContent = val;
          b.appendChild(box); b.appendChild(nm);
        } else b.textContent = val;
        b.setAttribute('data-fj-qb-val', val); b.setAttribute('data-opt', i); vals.appendChild(b);
      });
      g.appendChild(vals); box.appendChild(g);
    });
    qbRender();
    qb.hidden = false; void qb.offsetWidth; qb.classList.add('is-open');
    setTimeout(function () { var f = $('.fj-qb__val.is-selected', qb) || $('[data-fj-qb-add]', qb); if (f) f.focus({ preventScroll: true }); }, 80);
  }
  // photo per value of option i, or null when that option is not shown as swatches: the product page says which option
  // is the colour (colorIndex); otherwise an option whose values all have their own, different photo (never a size)
  var SIZE_NAME = /size|gr(ö|oe)(ss|ß)e|taille|maat|taglia|tama(ñ|n)o|rozmiar|velikost|st(ø|o)rrelse|tamanho|サイズ|dimension/i;
  function swatchImages(p, i) {
    if (typeof p.colorIndex === 'number' && p.colorIndex !== i) return null;
    if (typeof p.colorIndex !== 'number' && SIZE_NAME.test(p.options[i].name || '')) return null;
    var map = {}, seen = {};
    for (var k = 0; k < p.options[i].values.length; k++) {
      var val = p.options[i].values[k], v = p.variants.filter(function (x) { return x.options[i] === val && x.image; })[0];
      if (!v) return null;
      map[val] = v.image; seen[v.image] = true;
    }
    return Object.keys(seen).length > 1 ? map : null;
  }
  function qbRender() {
    var qb = qbEl(), p = qbState.p, v = qbVariant();
    $$('.fj-qb__val', qb).forEach(function (b) {
      var i = Number(b.getAttribute('data-opt')), val = b.getAttribute('data-fj-qb-val'), on = qbState.sel[i] === val;
      b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var ok = p.variants.some(function (x) { return x.available && x.options[i] === val && x.options.every(function (o, k) { return k === i || o === qbState.sel[k]; }); });
      b.classList.toggle('is-unavailable', !ok);
    });
    $$('[data-fj-qb-cur]', qb).forEach(function (sp) { sp.textContent = qbState.sel[Number(sp.getAttribute('data-fj-qb-cur'))] || ''; });
    var img = $('[data-fj-qb-img]', qb), src = (v && v.image) || p.image;
    if (src) { img.src = src; img.hidden = false; } else img.hidden = true;
    $('[data-fj-qb-price]', qb).textContent = v ? v.price : '';
    var cmp = $('[data-fj-qb-compare]', qb); cmp.textContent = v && v.compare ? v.compare : ''; cmp.hidden = !(v && v.compare);
    var add = $('[data-fj-qb-add]', qb);
    if (!v) { add.textContent = qb.dataset.unavailable; add.disabled = true; }
    else if (!v.available) { add.textContent = qb.dataset.soldout; add.disabled = true; }
    else { add.textContent = qb.dataset.add.replace('[price]', v.price); add.disabled = false; }
    $('[data-fj-qb-error]', qb).hidden = true;
  }
  function qbSelect(btn) {
    var i = Number(btn.getAttribute('data-opt')), val = btn.getAttribute('data-fj-qb-val');
    qbState.sel[i] = val;
    if (!qbVariant()) {
      var c = qbState.p.variants.filter(function (x) { return x.options[i] === val; });
      var best = c.filter(function (x) { return x.available; })[0] || c[0];
      if (best) qbState.sel = best.options.slice();
    }
    qbRender();
  }
  // the sheet on its own over the product page (sticky Add to Cart), without the drawer panel behind it
  function qbChoose(p, trigger) {
    var d = cd(), qb = qbEl(); if (!d || !qb) return false;
    if (!d.classList.contains('is-open')) { d.hidden = false; d.classList.add('fj-cd--qb'); document.documentElement.classList.add('fj-lock'); }
    qbOpen(null, trigger, p); return true;
  }
  function qbAdd() {
    var qb = qbEl(), v = qbState && qbVariant(), btn = $('[data-fj-qb-add]', qb);
    if (!v || !v.available || btn.disabled) return;
    addVariant(btn, v.id).then(function () {
      var d = cd(), alone = d && d.classList.contains('fj-cd--qb');
      if (alone) d.classList.remove('fj-cd--qb');
      qbClose(alone);
      if (alone) cdOpen();   // like Add to Cart: the drawer shows what was added
    }).catch(function (j) {
      var e = $('[data-fj-qb-error]', qb); e.textContent = (j && (j.description || j.message)) || cd().dataset.error; e.hidden = false;
    });
  }
  function qbClose(instant) {
    var qb = qbEl(); if (!qb || qb.hidden) return;
    qb.classList.remove('is-open');
    var t = qbState && qbState.trigger; qbState = null;
    var d = cd();
    var hide = function () {
      if (!qb.classList.contains('is-open')) qb.hidden = true;
      if (d && d.classList.contains('fj-cd--qb') && !d.classList.contains('is-open')) { d.classList.remove('fj-cd--qb'); d.hidden = true; document.documentElement.classList.remove('fj-lock'); }
    };
    if (instant) hide(); else setTimeout(hide, 500);
    if (instant) return;
    if (t && document.contains(t)) t.focus({ preventScroll: true });
    else { var pn = $('.fj-cd__panel', cd()); if (pn) pn.focus({ preventScroll: true }); }
  }
  if (window.customElements && !customElements.get('fj-cart-drawer')) {
    customElements.define('fj-cart-drawer', class extends HTMLElement { open() { cdOpen(); } close() { cdClose(); } });
  }
  window.fjCart = { open: cdOpen, close: cdClose, refresh: refreshCart, apply: applySections, choose: qbChoose };
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('#cart-icon-bubble, [data-fj-cart-open]');
    if (opener && cd() && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) { e.preventDefault(); cdOpen(); return; }
    var d = cd(); if (!d || !d.contains(e.target)) return;
    var x;
    if (e.target.closest('[data-fj-qb-close]')) { qbClose(); return; }
    if (e.target.closest('[data-fj-cd-close]')) { e.preventDefault(); cdClose(); return; }
    if ((x = e.target.closest('[data-fj-cd-qty]'))) { var it = x.closest('.fj-cd__item'); changeQty(it, Number(it.dataset.qty) + Number(x.getAttribute('data-fj-cd-qty'))); return; }
    if ((x = e.target.closest('[data-fj-cd-remove]'))) { e.preventDefault(); changeQty(x.closest('.fj-cd__item'), 0); return; }
    if ((x = e.target.closest('[data-fj-cd-add]'))) { addVariant(x, x.getAttribute('data-fj-cd-add')).catch(function (j) { cdError(x, j && (j.description || j.message)); }); return; }
    if ((x = e.target.closest('[data-fj-cd-qb]'))) { qbOpen(x.getAttribute('data-fj-cd-qb'), x); return; }
    if ((x = e.target.closest('[data-fj-cd-scroll]'))) { scrollTrack(d, Number(x.getAttribute('data-fj-cd-scroll'))); return; }
    if ((x = e.target.closest('[data-fj-qb-val]'))) { qbSelect(x); return; }
    if (e.target.closest('[data-fj-qb-add]')) { qbAdd(); return; }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-fj-cd-qinput]'); if (!inp) return;
    var it = inp.closest('.fj-cd__item'), n = parseInt(inp.value, 10);
    if (isNaN(n) || n < 0) { inp.value = it.dataset.qty; return; }
    if (n !== Number(it.dataset.qty)) changeQty(it, n);
  });
  document.addEventListener('keydown', function (e) {
    var d = cd(); if (!d || !(d.classList.contains('is-open') || d.classList.contains('fj-cd--qb'))) return;
    var qb = qbEl(), qbOn = qb && !qb.hidden;
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-fj-cd-qinput]')) { e.preventDefault(); e.target.blur(); return; }
    if (e.key === 'Escape') { e.preventDefault(); if (qbOn) qbClose(); else cdClose(); return; }
    if (e.key !== 'Tab') return;
    var scope = qbOn ? $('.fj-qb__sheet', qb) : $('.fj-cd__panel', d);
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])', scope).filter(function (el) { return el.offsetParent !== null || el.getClientRects().length; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || !scope.contains(a) || a === scope)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !scope.contains(a))) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('mousemove', function (e) {
    var d = cd(); if (!d || !d.classList.contains('is-open')) return;
    var cl = e.target.classList, over = !!(cl && (cl.contains('fj-cd__overlay') || cl.contains('fj-qb__overlay')));
    d.classList.toggle('is-cursor', over);
    if (over) { var c = $('.fj-cd__cursor', d); if (c) { c.style.setProperty('--x', e.clientX + 'px'); c.style.setProperty('--y', e.clientY + 'px'); } }
  }, { passive: true });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* footer country (currency) + language selectors */
  function locClose(except) {
    $$('[data-fj-loc]').forEach(function (dd) {
      if (dd === except) return;
      var btn = $('.fj-loc__btn', dd), list = $('.fj-loc__list', dd);
      if (btn) btn.setAttribute('aria-expanded', 'false'); if (list) list.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fj-loc__btn');
    if (btn) {
      var dd = btn.closest('[data-fj-loc]'), list = $('.fj-loc__list', dd), open = btn.getAttribute('aria-expanded') === 'true';
      locClose(dd);
      btn.setAttribute('aria-expanded', open ? 'false' : 'true'); list.hidden = open;
      $$('img[data-src]', list).forEach(function (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }); // flags load on first open
      if (!open) { var sel = $('[aria-selected="true"]', list) || $('.fj-loc__opt', list); if (sel) { list.scrollTop = sel.offsetTop - list.clientHeight / 2 + sel.offsetHeight / 2; sel.focus({ preventScroll: true }); } }
      return;
    }
    var opt = e.target.closest('[data-fj-loc-set]');
    if (opt) {
      var form = opt.closest('form'), input = form && form.querySelector('input[name="' + opt.getAttribute('data-fj-loc-set') + '"]');
      if (!input) return;
      if (opt.getAttribute('data-fj-loc-set') === 'country_code') { try { localStorage.setItem('fj-country-choice', opt.getAttribute('data-value')); } catch (x) {} }
      input.value = opt.getAttribute('data-value'); locClose(); form.submit(); return;
    }
    if (!e.target.closest('[data-fj-loc]')) locClose();
  });
  document.addEventListener('keydown', function (e) {
    var list = e.target.closest && e.target.closest('.fj-loc__list');
    if (e.key === 'Escape' && (list || e.target.closest && e.target.closest('[data-fj-loc]'))) { var dd = e.target.closest('[data-fj-loc]'); locClose(); var b = dd && $('.fj-loc__btn', dd); if (b) b.focus(); return; }
    if (!list || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
    e.preventDefault();
    var opts = $$('.fj-loc__opt', list), i = opts.indexOf(document.activeElement);
    var n = opts[Math.max(0, Math.min(opts.length - 1, i + (e.key === 'ArrowDown' ? 1 : -1)))]; if (n) n.focus();
  });

  /* reviews bar: open Loox's "all reviews" window (from the invisible Loox trust badge in the same section) */
  document.addEventListener('click', function (e) {
    var bar = e.target.closest('[data-fj-loox-open]'); if (!bar) return;
    var w = bar.parentNode.querySelector('.fj-rating-bar__loox loox-trust-badge-widget');
    var target = w && w.shadowRoot && w.shadowRoot.querySelector('[role="button"]');
    if (!target) return; // Loox not loaded (yet): follow the link
    e.preventDefault();
    target.click();
  });

  /* ---------- visitor's country (IP) in "[country]" texts: Shopify's own geolocation, only countries we sell to ---------- */
  var fjCountry = (function () {
    var KEY = 'fj-ip-country', pending = null;
    function names() { var el = document.getElementById('fj-countries'); try { return el ? JSON.parse(el.textContent) : {}; } catch (x) { return {}; } }
    function detect() {
      if (pending) return pending;
      var cached = null; try { cached = sessionStorage.getItem(KEY); } catch (x) {}
      if (cached !== null) return (pending = Promise.resolve(cached));
      pending = fetch(ROOT + 'browsing_context_suggestions.json').then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        var c = (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || '';
        try { sessionStorage.setItem(KEY, c); } catch (x) {}
        return c;
      }).catch(function () { return ''; });
      return pending;
    }
    function none() { var el = document.getElementById('fj-ship-none'); try { return el ? JSON.parse(el.textContent) : {}; } catch (x) { return {}; } }
    function apply(scope) {
      if (!$('[data-fj-country]', scope || document)) return;
      var cur = (document.getElementById('fj-countries') || {}).getAttribute ? document.getElementById('fj-countries').getAttribute('data-current') : '';
      var chosen = null; try { chosen = localStorage.getItem('fj-country-choice'); } catch (x) {}
      if (chosen && chosen === cur) return; // the visitor picked this country in the selector: show the shop's (chosen) country
      if (chosen && chosen !== cur) { try { localStorage.removeItem('fj-country-choice'); } catch (x) {} }
      detect().then(function (code) {
        if (!code) return; // lookup failed: keep the shop's own country
        var n = names()[code];
        if (n) { $$('[data-fj-country]', scope || document).forEach(function (el) { if (el.textContent !== n) el.textContent = n; }); return; }
        // a country we do not ship to: never promise shipping there, show the line without a country
        var t = none();
        $$('[data-fj-ship]', scope || document).forEach(function (el) { var v = t[el.getAttribute('data-fj-ship')]; if (v && el.textContent !== v) el.textContent = v; });
      });
    }
    return { apply: apply, detect: detect };
  })();

  /* ---------- boot (also after theme-editor section reloads) ---------- */
  function boot(scope) {
    chrome();
    $$('[data-fj-rail-wrap]', scope).forEach(initRail);
    $$('[data-fj-recs]', scope).forEach(initRecs);
    $$('[data-fj-product]', scope).forEach(initProduct);
    fjCountry.apply(scope);
    if (vio) $$('video[data-fj-autoplay]', scope).forEach(function (v) { vio.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  window.addEventListener('resize', chrome);
  window.addEventListener('load', chrome);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
